import React, { useEffect, useState } from "react";
import Account from "../../../sections/BusinessDashboard/Settings/Account";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { Formik, Form } from "formik";
import {
  defaultValues,
  validationSchema,
} from "../../../FormValidations/Latest/BusinessAccount";
import useAuth from "../../../Hooks/useAuth";
import { useSelector } from "react-redux";

// Separate component to handle auto-save with useEffect
const FormWrapper = ({ setFieldValue, values }) => {
  // Auto-save whenever values change
  useEffect(() => {
    localStorage.setItem("formData", JSON.stringify(values));
  }, [values]);

  return (
    <Form className="w-full">
      <Account values={values} setFieldValue={setFieldValue} />
    </Form>
  );
};

const Accounts = () => {
  const { auth } = useAuth();
  const user = useSelector((state) => state.user);
  
  // Set initial values on mount
  const [initialValues, setInitialValues] = useState(defaultValues);

  useEffect(() => {
    const savedData =
      JSON.parse(localStorage.getItem("formData")) || defaultValues;
    
    // Prefill primary location from user's business location
    const userLocation = user?.location || auth?.location || "";
    const updatedData = {
      ...savedData,
      primaryLocation: userLocation || savedData.primaryLocation
    };
    
    setInitialValues(updatedData);
  }, [user, auth]);

  const handleSubmit = (values) => {
    console.log("Form data:", values);
    localStorage.setItem("formData", JSON.stringify(values));
  };
  
  return (
    <>
      <DashboardMainContainer className={"!bg-white"}>
        <div className="flex justify-center">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize // Ensures reinitialization of form values on step change
          >
            {({ setFieldValue, values }) => (
              <FormWrapper setFieldValue={setFieldValue} values={values} />
            )}
          </Formik>
        </div>
      </DashboardMainContainer>
    </>
  );
};

export default Accounts;
